import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';

import {
  Event,
  Router,
  NavigationStart,
  NavigationEnd,
} from '@angular/router';
import { PlatformLocation } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {
  currentUrl: string;
  showLoadingIndicatior = true;
  private destroy$ = new Subject<void>();

  constructor(public _router: Router, location: PlatformLocation, private cdr: ChangeDetectorRef) {

    this._router.events.pipe(takeUntil(this.destroy$)).subscribe((routerEvent: Event) => {
      if (routerEvent instanceof NavigationStart) {
        this.showLoadingIndicatior = true;
        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf('/') + 1
        );
      }
      if (routerEvent instanceof NavigationEnd) {
        this.showLoadingIndicatior = false;
      }
      this.cdr.detectChanges();
      window.scrollTo(0, 0);
    });

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
